<div class="container">


        <div class="row">
            <div class="offset-lg-2 col-lg-8 offset-lg-2">
                <mat-card appearance="outlined" class="example-card">
                    <mat-card-header>
                        <mat-card-title>Karussell Web Startseite bearbeiten</mat-card-title>
                        <mat-card-subtitle>Hier können Sie die Inhalte von Werbeflächenkomponenten festlegen. Hierfür
                            stehen
                            Ihnen die versteckten Aktionen zur Verfügung.</mat-card-subtitle>
                    </mat-card-header>
                    <mat-card-content>
                        <div class="row " [formGroup]="tyepSelectForm">
                            <div class="col-sm-12">
                                <mat-form-field class="full-width">
                                    <mat-label>Typ:</mat-label>
                                    <mat-select formControlName="type">
                                        <mat-option *ngFor="let sortOption of sortOptions" [value]="sortOption.value"
                                            [disabled]="sortOption.state">
                                            {{sortOption.viewValue}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>


                        <div class="row" *ngIf="this.tyepSelectForm.value.type == 'component_web_landing_page'">
                            <div class="col-sm-12" style="display: flex;">
                                <div class="example-container">
                                    <h4>Zugeordnete Aktionen:</h4>

                                    <div cdkDropList #todoList="cdkDropList" [cdkDropListData]="inUseEvents"
                                        [cdkDropListConnectedTo]="[doneList]" class="example-list"
                                        (cdkDropListDropped)="drop($event)">
                                        <div class="example-box" (cdkDragStarted)="handleDragStart($event)"
                                            (click)="deltefromListEvents($event,item)" *ngFor="let item of inUseEvents"
                                            cdkDrag>{{item.title }}
                                        </div>
                                    </div>
                                </div>
                                <!-- <div style="display: flex; flex-direction: column; align-items: center;height: 100%;justify-content: center;">
                                <button mat-icon-button aria-label="Example icon button with a vertical three dot icon">
                                    <mat-icon>keyboard_arrow_left</mat-icon>
                                  </button>
                            </div> -->

                                <div class="example-container">
                                    <h4>Verfügbare Aktionen:</h4>

                                    <div cdkDropList #doneList="cdkDropList" [cdkDropListData]="avalibleEvents"
                                        [cdkDropListConnectedTo]="[todoList]" class="example-list"
                                        (cdkDropListDropped)="drop($event)">
                                        <div class="example-box" (cdkDragStarted)="handleDragStart($event)"
                                            (click)="addToListEvents($event,item)" *ngFor="let item of avalibleEvents"
                                            cdkDrag>{{item.title}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row" *ngIf="this.tyepSelectForm.value.type == 'component_advent'">
                            <div class="col-sm-12" style="display: flex;">
                                <div class="example-container">
                                    <h4>Zugeordnete Aktionen:</h4>

                                    <div cdkDropList #activeAdvent="cdkDropList" [cdkDropListData]="inUseEvents_Advent "
                                        [cdkDropListConnectedTo]="[inactiveAdvent]" class="example-list"
                                        (cdkDropListDropped)="drop($event)">
                                        <div class="example-box" *ngFor="let item of inUseEvents_Advent " cdkDrag
                                            (cdkDragStarted)="handleDragStart($event)"
                                            (click)="deltefromListAdvents($event,item)">
                                            {{item.title }}
                                        </div>
                                    </div>
                                </div>

                                <div class="example-container">
                                    <h4>Verfügbare Aktionen:</h4>

                                    <div cdkDropList #inactiveAdvent="cdkDropList"
                                        [cdkDropListData]="avalibleEvents_Advent "
                                        [cdkDropListConnectedTo]="[activeAdvent]" class="example-list"
                                        (cdkDropListDropped)="drop($event)">
                                        <div class="example-box" *ngFor="let item of avalibleEvents_Advent " cdkDrag
                                            (cdkDragStarted)="handleDragStart($event)"
                                            (click)="addToListAdvents($event,item)">
                                            {{item.title}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" *ngIf="this.tyepSelectForm.value.type == 'component_app_service_center'">
                            <div class="col-sm-12" style="display: flex;">
                                <div class="example-container">
                                    <h4>Zugeordnete Aktionen:</h4>

                                    <div cdkDropList #activeServiceCentre="cdkDropList"
                                        [cdkDropListData]="inUseEvents_ServiceCentre "
                                        [cdkDropListConnectedTo]="[inactiveServiceCentre]" class="example-list"
                                        (cdkDropListDropped)="drop($event)">
                                        <div class="example-box" *ngFor="let item of inUseEvents_ServiceCentre "
                                            cdkDrag>
                                            {{item.title }}
                                        </div>
                                    </div>
                                </div>

                                <div class="example-container">
                                    <h4>Verfügbare Aktionen:</h4>

                                    <div cdkDropList #inactiveServiceCentre="cdkDropList"
                                        [cdkDropListData]="avalibleEvents_ServiceCentre "
                                        [cdkDropListConnectedTo]="[activeServiceCentre]" class="example-list"
                                        (cdkDropListDropped)="drop($event)">
                                        <div class="example-box" *ngFor="let item of avalibleEvents_ServiceCentre "
                                            cdkDrag>
                                            {{item.title}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-card-content>
                    <mat-card-actions align="end">
                        <button mat-button color="primary" (click)="updateAdvertisingTiles()"
                            *ngIf="this.tyepSelectForm.value.type == 'component_web_landing_page'">Änderungen
                            speichern</button>
                        <button mat-button color="primary" (click)="updateAdventTiles()"
                            *ngIf="this.tyepSelectForm.value.type == 'component_advent'">Änderungen
                            speichern</button>
                        <button mat-button color="primary" (click)="updateServiceCentre()"
                            *ngIf="this.tyepSelectForm.value.type == 'component_app_service_center'">Änderungen
                            speichern</button>

                        <button mat-button color="primary" (click)="updateAdvertsing()" disabled
                            *ngIf="this.tyepSelectForm.value.type == 'component_web_intro_landing_page'">Änderungen
                            speichern</button>
                    </mat-card-actions>
                </mat-card>
            </div>
        </div>
        <div class="row" *ngIf="loading">
            <div class="offset-lg-2 col-lg-8 offset-lg-2">
                <div class="loadingOverlay">
                    <mat-spinner></mat-spinner>
                </div>
            </div>
    </div>